var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{class:`dimensions-stars-${_setup.props.sizing}`,attrs:{"src":`https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-${_setup.props.stars}.svg`,"alt":"TrustPilot Stars Rating"}})
}
var staticRenderFns = []

export { render, staticRenderFns }